import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_API_URL from '../../apis/index';
import { Box, Card, CardContent, Chip, Typography, Link, Button } from '@mui/material';
import { Carousel } from 'react-bootstrap';
import styled from 'styled-components';

export default function CompProductsSectionIngManf({ compId, compName, compTypes, userId }) {
    // const navigate = useNavigate();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        async function fetchProducts() {
            try {
                const authToken = localStorage.getItem("authToken");
                const res = await axios.get(`${BASE_API_URL}/api/seller/company/products/${compId}`, {
                    params: { company_type: "Ingredient Manufacturer" },
                    headers: { Authorization: `Bearer ${authToken}` },
                });
                setProducts(res.data.result || []);

                // setProductsLen(res.data.length || 0);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        }
        fetchProducts();
    }, [compId]);

    return (
        <CompProductsSectionWrapper className="py-md-5 p-4 bg-light my-4 rounded-4">
            <div className={`d-flex align-items-center justify-content-between ${products.length && "pb-3 border-bottom mb-4"}`}>
                <h4 className='fw-normal txt_color_primary'> Products - Ingredient Manufacturer ({products.length}) </h4>
                <div>
                    <Link href={`/user-product-register-bulk?compId=${compId}&compName=${compName}&companytype=${'Ingredient Manufacturer'}`}>
                        <Button variant="outlined" color='primary' size="medium" className="mb-0 shadow-none bg-light me-2"> Bulk Upload Products </Button>
                    </Link>
                    <Link href={`/user-product-register?compId=${compId}&compName=${compName}&companytype=${'Ingredient Manufacturer'}`}>
                        <Button variant="contained" color='primary' size="medium" className="mb-0 shadow-none"> Add Products </Button>
                    </Link>
                </div>
            </div>
            <div className="d-flex flex-wrap gap-3" spacing={3}>
                {products.length > 0 && products.map((product) => {
                    const images = product.product_images ? JSON.parse(product.product_images) : [];
                    return (
                        <div className="ProductCard" key={product.id}>
                            <Card sx={{ borderRadius: 3, overflow: "hidden" }} className='rounded-3 overflow-hidden shadow-none border'>
                                {/* Product Image Carousel */}
                                {images.length > 0 ? (
                                    <Carousel indicators={false} wrap={false}>
                                        {images.map((img, idx) => (
                                            <Carousel.Item key={idx}>
                                                <img
                                                    className="d-block w-100"
                                                    src={`${BASE_API_URL}/uploads/user_prod_docs/${img}`}
                                                    alt={`product-${product.id}-${idx}`}
                                                    style={{
                                                        height: "200px",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            </Carousel.Item>
                                        ))}
                                    </Carousel>
                                ) : (
                                    <Box
                                        sx={{
                                            height: 200,
                                            background: "#f0f0f0",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Typography variant="body2" color="text.secondary">
                                            No Image
                                        </Typography>
                                    </Box>
                                )}

                                {/* Product Details */}
                                <CardContent>
                                    <Typography variant="h6" gutterBottom> {product.product_name} </Typography>
                                    <Chip className='mb-2 rounded-1' label={<span className="text-white"> {product.category} </span>} size="small" sx={{ mr: 1 }} color="secondary" />

                                    <Typography variant="body2" color="text.secondary"> Type: {product.product_type} </Typography>
                                    <Typography variant="body2" color="text.secondary" className='mb-4'> Price: {product.pricing} {product.currency} </Typography>
                                    {/* <Typography variant="body2" color="text.secondary" className="mb-4"> Status: {product.status} </Typography> */}

                                    <a className="CardLink" href={`/user-product-details?prodId=${product.id}`}>
                                        View Details
                                    </a>
                                </CardContent>
                            </Card>
                        </div>
                    );
                })}
            </div>
        </CompProductsSectionWrapper>
    );
}

const CompProductsSectionWrapper = styled.div`
    .ProductCard{
        width: 380px;
        height: 420px;
    }
    .CardLink{
        border: 1px solid var(--secondary-color);
        padding: 10px 25px; 
        color: var(--secondary-color);
        font-size: 0.8rem;
        text-decoration: none;
        cursor: pointer;
        border-radius: 5px;
        transition: 0.5s;
        &:hover{
          background: var(--secondary-color);
          color: white;
        }
    }
`;
